import http from './http';
import notifier from '../_utils/notifier';
import axiosInstance, { CancelToken } from './config';
import Cookie from '../_utils/cookie';
import { SHOP_TYPES } from '../config';

const csrftoken = new Cookie('csrftoken');
export let cancelRequest = undefined;

const shopAPI = {
  getAllShopList(type, query){
    let source = CancelToken.source();
    return axiosInstance.get(
      `shop/?shopoffers_type=${type}&search=${query}`,
      {
        cancelToken: new CancelToken(function executor(c) { cancelRequest = c; })
      }
    ).then(response => response.data);
  },

  getOfferRelatedList(offer_id) {
    return axiosInstance.get(`shop/${offer_id}/offer-related/`).then(response => response.data);
  },

  deleteRelatedOffer(offer_id, id){
    return axiosInstance.delete(`shop/${offer_id}/offer-related/`,
      {
        params: { related_id: id },
        headers: {'X-CSRFToken': csrftoken.get()}
      }
    )
    .then(response => ({status: response.status, data: response.data}))
    .catch(error => ({status: error.response.status, data: error.response.data}));
  },

  createRelatedOffer(offer_id, data){
    return axiosInstance.post(`shop/${offer_id}/offer-related/`,
      data,
      {
        headers: {
          'X-CSRFToken': csrftoken.get(),
        }
      })
      .then(response => ({ status: response.status, data: response.data }))
  },

  getTechniquesList(exclude_ids) {
    return axiosInstance.get('shop/techniques/',
      { params: { 'exclude': exclude_ids } }
     ).then(response => response.data);
  },

  getOfferTechniquesList(offer_id) {
    return axiosInstance.get(`shop/${offer_id}/offer-techniques/`).then(response => response.data);
  },

  deleteTechnique(offer_id, id){
    return axiosInstance.delete(`shop/${offer_id}/offer-techniques/`,
      {
        params: { technique_id: id },
        headers: {'X-CSRFToken': csrftoken.get()}
      }
    )
    .then(response => ({status: response.status, data: response.data}))
    .catch(error => ({status: error.response.status, data: error.response.data}));
  },

  createTechnique(offer_id, data){
    return axiosInstance.post(`shop/${offer_id}/offer-techniques/`,
      data,
      {
        headers: {
          'X-CSRFToken': csrftoken.get(),
        }
      })
      .then(response => ({status: response.status, data: response.data}))
  },

  buyOffer(id, payload) {
    return http.post(`shop/buy/${id}/`, payload)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При покупке товара произошла ошибка. ') + '<br>' + error.messages);
        throw new Error(error.messages);
      }
    )
  },

  getTagsList(type) {
    return http.get(`shop/tags/${type}/`)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getComposersList() {
    return http.get('shop-composers/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getPerformersList() {
    return http.get('shop-performers/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getFilmsList() {
    return http.get('shop-films/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getDifficultyList() {
    return http.get('shop/difficulties/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getTonalityList() {
    return http.get('shop/tonalities/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getSystemsList() {
    return http.get('shop/systems/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getList(type, moderator=false) {
    let url = SHOP_TYPES[type]['url'];
    if (moderator) url = url + 'mlist/';
    return http.get(url)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  delete(type, id){
    return http.delete(SHOP_TYPES[type]['url'] + id + '/')
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении товара произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  create(type, payload) {
    return http.post(SHOP_TYPES[type]['url'], payload)
    .then(
      function(success) { return success },
      function(error) {
        return {
          error: true,
          data: error.messages
        }
      }
    );
  },

  getOffer(type, id, moderator=false) {
    let url = SHOP_TYPES[type]['url'] + id + '/';
    if (moderator) url = url + 'mget/';

    return http.get(url)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
        throw new Error(error.messages);
      }
    );
  },

  update(type, id, payload, moderator=false) {
    let url = SHOP_TYPES[type]['url'] + id + '/';
    if (moderator) url = url + 'mudpate/';
    return http.patch(url,{...payload})
    .then(
      function(success) { return success },
      function(error) {
        return {
          error: true,
          data: error.messages
        }
      }
    );
  },

  uploadOfferImage(payload, id) {
    return http.post('shop/image/' + id + '/', payload,
      { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При сохранени изображения произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getUserFileImages(url, opener='') {
    return http.get(url, { params: {opener: opener} })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
        throw new Error(error.messages);
      }
    );
  },

  getUserFilesList(url) {
    return http.get(url)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
        throw new Error(error.messages);
      }
    );
  },
};


export default shopAPI;
